var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0556 25.3057L73.3472 28.2641C76.9861 28.7919 78.4445 33.278 75.8056 35.8474L61.125 50.153L64.5972 70.3613C65.2222 74.0141 61.375 76.7363 58.1528 75.0419L40 65.5002L21.8472 75.0419C18.625 76.7502 14.7778 74.0141 15.4028 70.3613L18.875 50.153L4.19446 35.8474C1.55557 33.278 3.0139 28.7919 6.65279 28.2641L26.9445 25.3057L36.0139 6.91685C37.6528 3.59741 42.3611 3.63908 43.9861 6.91685L53.0556 25.3057Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStarFilled);
export default __webpack_public_path__ + "static/media/rating-star-filled.79db4ad1236b841d8841c250b5952b43.svg";
export { ForwardRef as ReactComponent };